import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentArrowRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDocumentArrowRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 17.5h9a1 1 0 0 0 1-1V8.493h-5.493V2.5H5.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1m6.007-14.285 3.82 3.778h-3.82zM14.5 19h-9A2.5 2.5 0 0 1 3 16.5v-13A2.5 2.5 0 0 1 5.5 1h5.078a2 2 0 0 1 1.406.578l4.422 4.373A2 2 0 0 1 17 7.373V16.5a2.5 2.5 0 0 1-2.5 2.5m-4.221-8.405a.75.75 0 0 1 1.06 0l2.122 2.121.53.53-.53.53-2.121 2.122a.75.75 0 0 1-1.061-1.06l.837-.838H7.403a.75.75 0 0 1 0-1.5h3.72l-.844-.845a.75.75 0 0 1 0-1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentArrowRight20);
